import axios from "axios";
import { BACKEND_URL } from "../constants/Constant";

const BASE_URL = `${BACKEND_URL}/schedule`;

const getSchedule = async () => {
  try {
    const response = await axios.get(BASE_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedule:", error);
    throw error;
  }
};

export { getSchedule };